import { jsx, jsxs } from 'react/jsx-runtime';
import * as React from 'react';
import { j as EGDSLayoutFlexItem, i as EGDSLayoutFlex } from '../layout-flex-item/index-chunk.esm.js';
import { c as classNames } from '../index_orig/index-chunk.esm.js';
import { throttle } from 'throttle-debounce';
import { a as EGDSIcon, E as EGDSIconSize } from '../icon/index-chunk.esm.js';
import styles from '../styles/uitk-egds-toolbar.css';
import { a as analyticsTracker } from '../analytics-tracker/index-chunk.esm.js';

const ToolbarContainerTagMap = [
    ['div', 'div'],
    ['header', 'header'],
    ['section', 'section'],
];
const EGDSToolbarContainerTags = new Map(ToolbarContainerTagMap);
const EGDSToolbarNavigationTypeIconsMap = [
    ['close', 'close'],
    ['back', 'arrow_back'],
    ['expand_up', 'expand_less'],
    ['expand_down', 'expand_more'],
];
const EGDSToolbarNavigationTypeIcons = new Map(EGDSToolbarNavigationTypeIconsMap);
const EGDSToolbarTitleTagMap = [
    ['h1', 'h1'],
    ['h2', 'h2'],
    ['h3', 'h3'],
    ['h4', 'h4'],
    ['h5', 'h5'],
    ['h6', 'h6'],
];
const EGDSToolbarTitleTags = new Map(EGDSToolbarTitleTagMap);
const EGDSToolbarTypesMap = [
    ['standard', 'standard'],
    ['transparent', 'transparent'],
];
const EGDSToolbarTypes = new Map(EGDSToolbarTypesMap);

const getClassNameList$4 = classNames.bind(styles);
// To be cleaned up
var ToolbarHeaderType;
(function (ToolbarHeaderType) {
    ToolbarHeaderType["OVERLAY"] = "Overlay";
})(ToolbarHeaderType || (ToolbarHeaderType = {}));
var EGDSToolbarExpandedState;
(function (EGDSToolbarExpandedState) {
    EGDSToolbarExpandedState["EXPANDED"] = "expanded";
    EGDSToolbarExpandedState["COLLAPSED"] = "collapsed";
})(EGDSToolbarExpandedState || (EGDSToolbarExpandedState = {}));
class Toolbar extends React.Component {
    static displayName = 'EGDSToolbar';
    static baseClassName = 'uitk-toolbar';
    isElevatedToolbar;
    constructor(props) {
        super(props);
        this.state = {
            elevatedToolbar: false,
        };
        this.isElevatedToolbar = false;
        this.handleScroll = throttle(100, this.handleScroll.bind(this));
    }
    componentDidUpdate() {
        const { contentDomRef } = this.props;
        const domRef = contentDomRef;
        if (domRef && domRef.current && typeof domRef.current.addEventListener === 'function') {
            domRef.current.addEventListener('scroll', this.handleScroll);
        }
    }
    componentWillUnmount() {
        const { contentDomRef } = this.props;
        const domRef = contentDomRef;
        if (domRef && domRef.current && typeof domRef.current.removeEventListener === 'function') {
            domRef.current.removeEventListener('scroll', this.handleScroll);
        }
    }
    handleScroll(event) {
        if (event.target.scrollTop > 0) {
            if (!this.isElevatedToolbar) {
                this.toggleElevatedState(true);
            }
        }
        else {
            this.toggleElevatedState(false);
        }
    }
    toggleElevatedState(isElevated) {
        this.setState({
            elevatedToolbar: isElevated,
        }, () => {
            this.isElevatedToolbar = isElevated;
        });
    }
    render() {
        const { id, className, toolbarType, children, childClassName, navigationContent, toolbarActionContent, toolbarTitle, toolbarTitleTag, toolbarSubtitle, toolbarTitleA11yText, } = this.props;
        const { elevatedToolbar } = this.state;
        const containerClassNames = getClassNameList$4(className, toolbarType && EGDSToolbarTypes.get(toolbarType) === 'transparent' && 'uitk-toolbar-transparent', {
            elevated: elevatedToolbar,
            'has-placeholder': children,
        });
        const Tag = ((toolbarTitleTag && EGDSToolbarTitleTags.get(toolbarTitleTag)) ||
            EGDSToolbarTitleTags.get('h2'));
        const toolbarSubtitleClassname = getClassNameList$4(`${Toolbar.baseClassName}-subtitle-content`);
        const toolbarSubtitleContent = toolbarSubtitle &&
            (typeof toolbarSubtitle === 'string' ? (jsx("p", { className: toolbarSubtitleClassname, children: toolbarSubtitle })) : (React.cloneElement(toolbarSubtitle, { className: toolbarSubtitleClassname })));
        const { navType, navIconLabel, navButtonLabel, onClick, onClickAnalytics, navButtonRef, navButtonId } = navigationContent || {};
        const iconType = ((navType && EGDSToolbarNavigationTypeIcons.get(navType)) ||
            EGDSToolbarNavigationTypeIcons.get('close'));
        let expandedState;
        if (navType === 'expand_down')
            expandedState = EGDSToolbarExpandedState.EXPANDED;
        if (navType === 'expand_up')
            expandedState = EGDSToolbarExpandedState.COLLAPSED;
        return (jsxs(EGDSToolbarContainer, { id: id, className: containerClassNames, children: [navigationContent && onClick && (jsxs(EGDSToolbarButton, { onClick: onClick, onClickAnalytics: onClickAnalytics, buttonId: navButtonId, buttonRef: navButtonRef, expandedState: expandedState ?? undefined, containerId: expandedState ? id : undefined, children: [jsx(EGDSIcon, { id: `${navButtonId}-${iconType}-toolbar`, name: iconType, size: EGDSIconSize.MEDIUM, title: navIconLabel }), navButtonLabel] })), jsx(EGDSLayoutFlexItem, { grow: 1, className: getClassNameList$4('truncate'), children: jsxs("section", { children: [toolbarTitle && (jsx(Tag, { className: getClassNameList$4(`${Toolbar.baseClassName}-title-content`), "aria-hidden": toolbarTitleA11yText ? 'true' : 'false', children: toolbarTitle })), toolbarTitleA11yText && (jsx(Tag, { className: getClassNameList$4('is-visually-hidden'), children: toolbarTitleA11yText })), toolbarSubtitle && toolbarSubtitleContent] }) }), toolbarActionContent, children && (jsx(EGDSLayoutFlexItem, { className: getClassNameList$4(childClassName), minWidth: "full_width", children: jsx("section", { children: children }) }))] }));
    }
}

const getClassNameList$3 = classNames.bind(styles);
class EGDSToolbar extends React.Component {
    static displayName = 'EGDSStandardToolbar';
    render() {
        const { elevation, className, ...props } = this.props;
        let elevationClassName = '';
        if (elevation === 'flat') {
            elevationClassName = `${Toolbar.baseClassName}-${elevation}`;
        }
        else if (elevation === 'floating') {
            elevationClassName = `${elevation}`;
        }
        const wrapperClassNames = getClassNameList$3(elevationClassName, className);
        return jsx(Toolbar, { className: wrapperClassNames, ...props });
    }
}

const getClassNameList$2 = classNames.bind(styles);
class EGDSToolbarContainer extends React.Component {
    static displayName = 'EGDSToolbarContainer';
    static defaultProps = {
        tag: 'div',
    };
    render() {
        const { id, className, children, tag } = this.props;
        // Renders the custom Tag
        const toolbarHeaderTag = ((tag && EGDSToolbarContainerTags.get(tag)) ||
            EGDSToolbarContainerTags.get('div'));
        const containerClassName = getClassNameList$2('uitk-toolbar', className);
        return (jsx(EGDSLayoutFlex, { id: id, alignItems: "center", className: containerClassName, tag: toolbarHeaderTag, children: children }));
    }
}

const getClassNameList$1 = classNames.bind(styles);
class EGDSTransparentToolbar extends React.Component {
    static displayName = 'EGDSTransparentToolbar';
    render() {
        const { overlay, className, ...props } = this.props;
        const wrapperClassNames = getClassNameList$1(overlay && `${Toolbar.baseClassName}-transparent-overlay`, className);
        return jsx(Toolbar, { className: wrapperClassNames, ...props, toolbarType: "transparent" });
    }
}

const getClassNameList = classNames.bind(styles);
class EGDSToolbarButton extends React.Component {
    static displayName = 'EGDSToolbarButton';
    render() {
        const { disabled, onClick, buttonRef, onClickAnalytics, buttonId, expandedState, containerId, children } = this.props;
        const analytics = onClickAnalytics && {
            localAnalyticsId: 'Close',
            ...onClickAnalytics,
        };
        let iconContent;
        let buttonLabel;
        // Map through the children and place the ones we want in specific places
        React.Children.forEach(children, (child) => {
            if (!child) {
                return;
            }
            if (child?.type?.displayName?.match(/(EGDS|Uitk)Icon/) && !iconContent) {
                iconContent = child;
            }
            else if (typeof child === 'string' && !buttonLabel) {
                buttonLabel = child;
            }
        });
        // Clean up 'v2' extension in class in EGDS graduation hard breaking change
        const baseClass = `${Toolbar.baseClassName}-button-v2`;
        const contentClass = `${baseClass}-content`;
        const wrapperClassName = getClassNameList(baseClass, !buttonLabel && `${baseClass}-icon-only`, buttonLabel && `${baseClass}-has-label`);
        const contentClassNames = getClassNameList(contentClass, !buttonLabel && `${contentClass}-icon-only`, buttonLabel && `${contentClass}-has-label`);
        return (jsx(EGDSLayoutFlexItem, { className: wrapperClassName, shrink: 0, children: jsx("button", { type: "button", disabled: disabled, onClick: onClick, onClickCapture: analyticsTracker.bind(this, analytics), ref: buttonRef, id: buttonId, "aria-expanded": expandedState === EGDSToolbarExpandedState.EXPANDED, "aria-controls": containerId, children: jsxs("span", { className: contentClassNames, children: [iconContent, buttonLabel && jsx("span", { className: getClassNameList(`${contentClass}-label`), children: buttonLabel })] }) }) }));
    }
}

export { EGDSToolbarExpandedState as E, ToolbarHeaderType as T, Toolbar as a, EGDSToolbar as b, EGDSToolbarContainer as c, EGDSTransparentToolbar as d, EGDSToolbarButton as e };
//# sourceMappingURL=index-chunk.esm.js.map
